module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-22d629f293b3e6ed1a817f3595f48cc2.png";